import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import type { LearnerScore } from "@/constants/assessmentsReport.constants";

interface ResetButtonProps {
  rowData: LearnerScore;
  viewOnly: boolean;
  handleReset: (rowData: LearnerScore) => void;
  isResetting?: boolean;
  confirmMessage?: string;
  confirmHeader?: string;
}

export default function ResetButton({
  rowData,
  viewOnly,
  handleReset,
  isResetting = false,
  confirmMessage = "Resetting this assessment will erase the learner's current score",
  confirmHeader = "Are you sure?",
}: ResetButtonProps) {
  const handleClick = () => {
    confirmDialog({
      message: confirmMessage,
      header: confirmHeader,
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      acceptLabel: "Reset",
      rejectLabel: "Cancel",
      accept: () => handleReset(rowData),
      reject: () => {},
    });
  };

  return (
    <Button
      label="Reset"
      text
      onClick={handleClick}
      disabled={!rowData.resettable || viewOnly || isResetting}
      loading={isResetting}
    />
  );
}
